import React, { useState, useCallback } from 'react';
import { Card, Form, Row, Col, Button, Collapse } from 'react-bootstrap';
import { FaFilter, FaChevronDown, FaChevronUp, FaSearch, FaTimes } from 'react-icons/fa';

/**
 * Componente de filtros para ingresos de equipos
 * @param {Function} onFilter - Callback que recibe los filtros aplicados
 * @param {Function} onClear - Callback para limpiar filtros
 */
export const FiltrosIngreso = ({ onFilter, onClear }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filtros, setFiltros] = useState({
    numeroOrden: '',
    nameClient: '',
    estado: '',
    fechaIngresoDesde: '',
    fechaIngresoHasta: '',
    fechaSalidaDesde: '',
    fechaSalidaHasta: '',
  });

  const handleInputChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    setFiltros(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Limpiar filtros vacíos
    const filtrosLimpios = Object.entries(filtros).reduce((acc, [key, value]) => {
      if (value !== '' && value !== false) {
        acc[key] = value;
      }
      return acc;
    }, {});

    onFilter(filtrosLimpios);
  };

  const handleClear = () => {
    setFiltros({
      numeroOrden: '',
      nameClient: '',
      estado: '',
      fechaIngresoDesde: '',
      fechaIngresoHasta: '',
      fechaSalidaDesde: '',
      fechaSalidaHasta: '',
    });
    onClear && onClear();
  };

  return (
    <Card className="w-100 mb-4 shadow-sm border-0">
      <Card.Header 
        className="bg-primary text-white d-flex justify-content-between align-items-center cursor-pointer w-100"
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: 'pointer' }}
      >
        <div className="d-flex align-items-center">
          <FaFilter className="me-2" />
          <strong>Filtros de Búsqueda</strong>
        </div>
        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
      </Card.Header>
      
      <Collapse in={isOpen}>
        <Card.Body className="w-100">
          <Form onSubmit={handleSubmit}>
            {/* Sección: Filtros Principales */}
            <Row className="mb-3">
              <Col md={4} className="mb-3">
                <Form.Group>
                  <Form.Label className="text-secondary">Número de Orden</Form.Label>
                  <Form.Control
                    type="text"
                    name="numeroOrden"
                    value={filtros.numeroOrden}
                    onChange={handleInputChange}
                    placeholder="Ej: 36523"
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group>
                  <Form.Label className="text-secondary">Nombre del Cliente</Form.Label>
                  <Form.Control
                    type="text"
                    name="nameClient"
                    value={filtros.nameClient}
                    onChange={handleInputChange}
                    placeholder="Ej: IPS SALVANDO VIDAS"
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group>
                  <Form.Label className="text-secondary">Estado</Form.Label>
                  <Form.Select
                    name="estado"
                    value={filtros.estado}
                    onChange={handleInputChange}
                  >
                    <option value="">Todos los estados</option>
                    <option value="Abierta">Abierta</option>
                    <option value="Cerrada">Cerrada</option>
                    <option value="Anulado">Anulada</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {/* Sección: Fechas */}
            <Row className="mb-3">
              <Col md={12}>
                <h6 className="text-muted border-bottom pb-2 mb-3">
                  <i className="bi bi-calendar-event me-2"></i>
                  Rango de Fechas
                </h6>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label className="text-secondary">Fecha de Ingreso - Desde</Form.Label>
                  <Form.Control
                    type="date"
                    name="fechaIngresoDesde"
                    value={filtros.fechaIngresoDesde}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label className="text-secondary">Fecha de Ingreso - Hasta</Form.Label>
                  <Form.Control
                    type="date"
                    name="fechaIngresoHasta"
                    value={filtros.fechaIngresoHasta}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label className="text-secondary">Fecha de Salida Estimada - Desde</Form.Label>
                  <Form.Control
                    type="date"
                    name="fechaSalidaDesde"
                    value={filtros.fechaSalidaDesde}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group>
                  <Form.Label className="text-secondary">Fecha de Salida Estimada - Hasta</Form.Label>
                  <Form.Control
                    type="date"
                    name="fechaSalidaHasta"
                    value={filtros.fechaSalidaHasta}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Botones de Acción */}
            <Row className="mt-4">
              <Col className="d-flex justify-content-end gap-2">
                <Button 
                  variant="outline-secondary" 
                  type="button"
                  onClick={handleClear}
                  className="d-flex align-items-center"
                >
                  <FaTimes className="me-2" />
                  Limpiar
                </Button>
                <Button 
                  variant="primary" 
                  type="submit"
                  className="d-flex align-items-center px-4"
                >
                  <FaSearch className="me-2" />
                  Buscar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Collapse>
    </Card>
  );
};
